import { ACTION_CODE } from '@constants'

import { EMPTY_COMMAND_FORM } from '../constants'

export const getDefaultCommandValueByActionCode = (actionCode: ACTION_CODE) => {
  switch (actionCode) {
    case ACTION_CODE.EXECUTE_COMMAND:
      return EMPTY_COMMAND_FORM
    default:
      return []
  }
}
